<div class="heading py-5">
  <h1 class="bold font-curve-large">Form switch</h1>
  <app-dependency-link documentationPath="forms/checks-radios/#switches"></app-dependency-link>
</div>

<section>
  <app-switch-demo></app-switch-demo>
</section>
<code
  class="block"
  [highlight]="codeTemplate"
  [languages]="['html', 'scss', 'css', 'typescript', 'javascript']"
></code>
